module.exports = __webpack_public_path__ + "img/Button_GooglePlayEnabled-smv.1cbe7700.png";